
import Vue from 'vue'
import PointMap from '../common/point-map/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'MainMap',
  components: { PointMap },
  mixins: [staticBlockMixin],
  props: {
    hideButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      region: null
    }
  },
  async fetch () {
    try {
      this.region = (await this.$shops.fetch(this.mainFields?.officeTag?.value))?.[0] || null
    } catch (error) {
      console.error(error)
    }
  }
})
